import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useTaskListTemplateForm } from '@hooks/useTaskListTemplate'

import OrganizationSelector from '@components/OrganizationSelector'

interface TaskListTemplateDetailsProps {
  taskListTemplateFormPayload: ReturnType<typeof useTaskListTemplateForm>,
}

const TaskListTemplateDetails = (props: TaskListTemplateDetailsProps) => {
  const {
    taskListTemplateFormPayload: {
      entityState: {
        owner_id,
        owner_type,
        title,
      },
      errors,
      handlers,
      setEntityState,
    },
  } = props

  return (
    <DashboardModule title="Template Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.owner_type} label="* Owner Type">
            <select
              name="owner_type"
              value={owner_type}
              onChange={e => setEntityState({
                owner_id: undefined,
                owner_type: e.target.value,
              })}
            >
              <option value="">Please Select...</option>
              <option value="Agency">Agency</option>
              <option value="Brand">Brand</option>
              <option value="Provider">Provider</option>
              <option value="System">System</option>
            </select>
          </Form.Field>

          {owner_type === 'System' && (
            <Form.Field errorMessage={errors.owner_type} label="* Owner">
              <input disabled value="Default System" type="text" />
            </Form.Field>
          )}

          {!!owner_type && owner_type !== 'System' && (
            <OrganizationSelector
              callbacks={{
                selectItem: ({ entity }) => setEntityState({ owner_id: entity?.id }),
              }}
              entityType={owner_type}
              label="* Owner"
              selectedItemId={owner_id}
            />
          )}
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default TaskListTemplateDetails
